import React from 'react'
import { checkTextTranslation } from '../../utils/useful'

class ProgressInput extends React.Component {
    state = {
        persentage: 80
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }

    componentDidMount = () => {
        // console.log('progress',((Number(this.props.data).toFixed(0) >= 0 && this.props.data <= 25) ? '#FF3B30':'') + ((this.props.data >= 26 && this.props.data <= 50) ? '#FF9500':'') + ((this.props.data >= 51 && this.props.data <= 75) ? '#FFCC00':'') + ((this.props.data >= 76 && this.props.data <= 100) ? '#34C759':''))
        console.log("this.props.data4", this.props)
    }
    componentDidUpdate(prevProps) {
        if (prevProps.data != this.props.data) {
            console.log('this.props2', this.props.data)
        }
    }
    render() {
        return (
            <div className="w-100 h-100 flexcc">
                <div className='' style={{ width: '100%', height: '30px', borderRadius: '30px', position: 'relative', border: '1px solid #ddd', overflow: 'hidden', backgroundColor: (((Number(this.props.data).toFixed(0) ?? 0) >= 0 && (Number(this.props.data).toFixed(0) ?? 0) <= 25) ? '#FF3B30' : '') + (((Number(this.props.data).toFixed(0) ?? 0) >= 26 && (Number(this.props.data).toFixed(0) ?? 0) <= 50) ? '#FF9500' : '') + (((Number(this.props.data).toFixed(0) ?? 0) >= 51 && (Number(this.props.data).toFixed(0) ?? 0) <= 75) ? '#FFCC00' : '') + (((Number(this.props.data).toFixed(0) ?? 0) >= 76 && (Number(this.props.data).toFixed(0) ?? 0) <= 100) ? '#34C759' : '') }}>
                    <div className='h-100 flexcc' style={{ backgroundColor: 'white', width: `calc(100% - ${(this.props.data && Number(this.props.data).toFixed(0)) ?? 0}%)`, position: 'absolute' }}>
                    </div>
                    {this.props?.header?.information?.showPercentage && (
                        <p className='px-2 text-center' style={{ position: 'absolute', left: '35%', top: "20%", color: '#000', backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: '30px' }}>{(this.props.data && Number(this.props.data).toFixed(0)) ?? 0}%</p>
                    )}
                </div>
            </div>
        )
    }
}

export default ProgressInput;